(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // Swap a card from "Añadir" button to its quantity stepper (or back).
    function showStepper(card, qty) {
      const btn = card.querySelector('[data-add-to-cart]');
      const stepper = card.querySelector('[data-stepper]');
      const qtyEl = card.querySelector('[data-qty]');
      if (qty > 0) {
        if (btn) btn.hidden = true;
        if (stepper) stepper.hidden = false;
        if (qtyEl) qtyEl.textContent = String(qty);
      } else {
        if (btn) btn.hidden = false;
        if (stepper) stepper.hidden = true;
      }
    }

    // Sync EVERY card on the page to the current cart state. Promotes
    // hidden steppers to visible when a card's variant is in cart, and
    // demotes back to the Añadir button when it's removed. Runs on
    // first load AND on cart:updated so the UI mirrors the cart no
    // matter where the mutation came from.
    async function syncCardsToCart() {
      try {
        const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!r.ok) return;
        const cart = await r.json();
        const byVariant = new Map();
        for (const item of cart.items) byVariant.set(String(item.variant_id), item.quantity);
        document.querySelectorAll('[data-stepper]').forEach((stepper) => {
          const card = stepper.closest('[data-card]');
          if (!card) return;
          const qty = byVariant.get(stepper.dataset.variantId) || 0;
          showStepper(card, qty);
        });
      } catch { /* swallow */ }
    }
    syncCardsToCart();
    document.addEventListener('cart:updated', syncCardsToCart);

    // Add-to-cart: simple variant → AJAX add → swap to stepper; multi-variant → open size drawer.
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      const isMulti = btn.dataset.multi === 'true';
      const handle = btn.dataset.handle;
      const variantId = btn.dataset.variantId;
      const card = btn.closest('[data-card]');
      if (isMulti) {
        document.dispatchEvent(new CustomEvent('size-drawer:open', { detail: { handle } }));
        return;
      }
      if (!variantId) return;
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        if (!res.ok) throw new Error('add failed');
        if (card) showStepper(card, 1);
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { variantId, handle, openDrawer: false } }));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (err) {
        console.error('[product-card] add to cart failed', err);
      } finally {
        btn.disabled = false;
      }
    });

    // Stepper +/− — adjust line item quantity. 0 reverts to "Añadir" button.
    document.addEventListener('click', async (e) => {
      const step = e.target.closest('[data-step]');
      if (!step) return;
      e.preventDefault();
      const card = step.closest('[data-card]');
      const stepper = step.closest('[data-stepper]');
      const qtyEl = stepper?.querySelector('[data-qty]');
      if (!card || !stepper || !qtyEl) return;
      const variantId = stepper.dataset.variantId;
      const delta = parseInt(step.dataset.step, 10);
      const current = parseInt(qtyEl.textContent, 10) || 0;
      const next = Math.max(0, current + delta);
      stepper.querySelectorAll('[data-step]').forEach((b) => (b.disabled = true));
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: next }),
        });
        if (!res.ok) throw new Error('change failed');
        showStepper(card, next);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (err) {
        console.error('[product-card] cart change failed', err);
      } finally {
        stepper.querySelectorAll('[data-step]').forEach((b) => (b.disabled = false));
      }
    });

    // Favorites — localStorage-backed toggle. Server-side counter would need a metafield API.
    const FAV_KEY = 'clab:favorites';
    const getFavs = () => { try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch { return []; } };
    const setFavs = (arr) => localStorage.setItem(FAV_KEY, JSON.stringify(arr));
    const favs = getFavs();
    document.querySelectorAll('[data-favorite]').forEach((btn) => {
      const id = btn.dataset.favorite;
      if (favs.includes(id)) btn.setAttribute('aria-pressed', 'true');
    });
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-favorite]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.dataset.favorite;
      const list = getFavs();
      const idx = list.indexOf(id);
      const countEl = btn.querySelector('[data-favorite-count]');
      let count = parseInt(countEl?.textContent || '0', 10) || 0;
      if (idx >= 0) {
        list.splice(idx, 1);
        btn.setAttribute('aria-pressed', 'false');
        count = Math.max(0, count - 1);
      } else {
        list.push(id);
        btn.setAttribute('aria-pressed', 'true');
        count += 1;
      }
      setFavs(list);
      if (countEl) countEl.textContent = String(count);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
